import { render } from "./index.vue?vue&type=template&id=4a21e7f4&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=4a21e7f4&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-4a21e7f4"

export default script